module.exports = __webpack_public_path__ + "img/done.b98a129e.svg";